import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetCurrentUserQuery } from "../../../api/auth";
import { actions } from "../../../redux/store/store";
import { datadogRum } from "@datadog/browser-rum";

const USER_ROLES = {
  ADMIN: "admin",
  NEW_ADMIN: "new_admin",
  ROOT: "root",
  BOOKKEEPER: "bookkeeper",
  METRO_MANAGER: "metro_manager",
  AREA_MANAGER: "area_manager",
  SR_HUB_MANAGER: "sr_hub_manager",
  HUB_MANAGER: "hub_manager",
  DRIVER_COMPLIANCE: "driver_compliance",
  HUB_LEAD: "hub_lead",
  DISPATCHER: "dispatcher",
  FINANCE_PAYMENTS: "finance_payments",
  REGIONAL_MANAGER: "regional_manager",
  SUPERVISOR: "supervisor",
};

const roleArr = Object.values(USER_ROLES);

const Callback = ({ userManager, onStopUserQuery }) => {
  const [getUserApi] = useLazyGetCurrentUserQuery();
  const navigate = useNavigate();

  const checkUser = async () => {
    try {
      const { data: user, error } = await getUserApi();
      if (!error) {
        if (roleArr.includes(user.role)) {
          onStopUserQuery(false);
          actions.auth.setCurrentUser(user);
          actions.auth.setLoading(false);
          actions.notifications.add({
            message: "Logged in",
            status: "success",
          });
          datadogRum.setUser({
            id: 'USER_ID',
            name: 'John Doe',
            email: 'john.doe@example.com',
            role: 'admin',
          });
          navigate(user.role === USER_ROLES.BOOKKEEPER ? "/deposit" : "/drivers", { replace: true });
        }
      } else {
        actions.notifications.add({
          message: error?.data || "Failed to fetch user data",
          status: "error",
        });
        localStorage.removeItem('authToken');
        await userManager.removeUser();
        await userManager.signoutRedirect();
        navigate("/login");
      }
    } catch (error) {
      actions.notifications.add({
        message: "Login failed..!",
        status: "error",
      });
      navigate("/login");
    } finally {
      sessionStorage.removeItem("isLoggingIn");
    }
  }

  const handleLogin = async () => {
    try {
      const user = await userManager.signinRedirectCallback();
      if (user) {
        localStorage.setItem('authToken', user.id_token);
        await checkUser();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleLogin()
  }, []);

  return null;
};

export default Callback;
